import { Label } from "@loot-os/ui/components/label";
import type { ReactNode } from "react";

/** One setting in a card of settings: its label and what it does beside the control. */
export function SettingRow({
  htmlFor,
  label,
  description,
  children,
}: {
  htmlFor: string;
  label: string;
  description: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="grid gap-3 py-5 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] md:gap-8">
      <div className="grid content-start gap-1">
        <Label htmlFor={htmlFor}>{label}</Label>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      <div className="min-w-0">{children}</div>
    </div>
  );
}
